// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_gw-a";
export var fulfillmentFormRail = "_gw-9";
export var headerTitleRow = "_gw-c";
export var orderDetailsWrapper = "_gw-7";
export var orderLinkTrigger = "_gw-2";
export var paymentInformationGrid = "_gw-h";
export var paymentSummaryColumn = "_gw-i";
export var shipmentContainer = "_gw-b";
export var shipmentDetailsMainPane = "_gw-8";
export var shipmentNavigationCard = "_gw-5";
export var shipmentNavigationRail = "_gw-3";
export var shipmentNavigationRailHeader = "_gw-4";
export var shipmentSummaryFact = "_gw-e";
export var shipmentSummaryGrid = "_gw-d";
export var shipmentSummaryMetadataRow = "_gw-f";
export var shipmentSummaryTags = "_gw-g";
export var shipmentWorkspace = "_gw-0";
export var shipmentWorkspaceContent = "_gw-6";
export var shipmentWorkspaceHeader = "_gw-1";